import React from 'react';
import LayoutMiniatureGrid from './LayoutMiniatureGrid';
import LayoutMiniatureCreateNew from './LayoutMiniatureCreateNew';
import queries from '../../utils/query';
import { useQuery } from '@apollo/client';
import Header from '../header/Header';
import HomeHeader from './HomeHeader';
import HomeSkeleton from './HomeSkeleton';
import { createStandaloneToast, Flex, useDisclosure } from '@chakra-ui/react';
import { Box, Grid } from '@chakra-ui/react';
import RemoveProjectModal from './RemoveProjectModal';
import { scrollBarStyle } from '../../utils/layoutConfig';
import CloningModal from './CloningModal';

const toastErrorGettingViews = (error) => ({
	title: `Ocorreu um erro ao buscar os projetos: ${error}`,
	status: 'error',
	duration: 3000,
	isClosable: true,
	position: 'top',
});

function getViewsData({ filter, filteredViewList, viewList }) {
	const { textFilter, stageFilter } = filter;
	if (filteredViewList && (filteredViewList.length || textFilter || stageFilter != 'all')) {
		return filteredViewList;
	} else {
		return viewList;
	}
}

const Home = ({ userInfo }) => {
	const { loading, error, data } = useQuery(queries.GET_VIEWS_LIST);
	const [viewList, setViewList] = React.useState([]);
	const [filteredViewList, setFilteredViewList] = React.useState([]);
	const [gridStyle, setGridStyle] = React.useState('grid');
	const [filter, setFilters] = React.useState({ textFilter: '', stageFilter: 'all', sort: 'creationDate' });
	const toast = createStandaloneToast();
	const { isOpen: dMIsOpen, onOpen: dMOnOpen, onClose: dMOnClose } = useDisclosure();
	const [cloningModalIsOpen, setCloningModalIsOpen] = React.useState(false);
	//view para deletar ao clicar em delete
	const [viewToDelete, setViewToDelete] = React.useState();

	React.useEffect(() => {
		if (data && data.viewLists) {
			setViewList(data.viewLists);
		}
	}, [data]);

	React.useEffect(() => {
		if (error) {
			toast(toastErrorGettingViews(error));
		}
	}, [error]);

	React.useEffect(() => {
		let newViewList = [...viewList];

		//filter by name
		newViewList = newViewList.filter((view, i) => {
			if (
				(view.description || '').toLowerCase().includes(filter.textFilter.toLocaleLowerCase()) ||
				(view.viewName || '').toLowerCase().includes(filter.textFilter.toLocaleLowerCase())
			) {
				return true;
			}
			return false;
		});

		//filter by type
		if (filter.stageFilter != 'all') {
			newViewList = newViewList.filter((view, i) => {
				if (view.stage == filter.stageFilter) {
					return true;
				}
				return false;
			});
		}
		//sort
		//modified date will be the default sort from db
		if (filter.sort != 'modifiedDate') {
			newViewList = newViewList.sort((a, b) => {
				if (filter.sort == 'name') {
					return a.name > b.firstname ? 1 : -1;
				}
				if (filter.sort == 'creationDate') {
					const aDate = new Date(Number(a.createdAt));
					const bDate = new Date(Number(b.createdAt));
					return aDate < bDate ? 1 : -1;
				}
			});
		}
		console.log(filter);
		setFilteredViewList(newViewList);
	}, [filter, viewList]);

	return (
		<React.Fragment>
			{/* <Header userInfo={userInfo}/> */}
			<Box maxW="1600px" margin="0 auto" h={'100%'} padding={'72px 76px 0 76px;'} className="HomeContainer">
				<HomeHeader {...{ setGridStyle, gridStyle, filter, setFilters }} />
				{loading && <HomeSkeleton></HomeSkeleton>}
				<Flex
					mt={6}
					px={1}
					pt={1}
					pb={6}
					mx={'-4px'}
					sx={scrollBarStyle}
					h={'80%'}
					flexWrap={'wrap'}
					overflowY={'auto'}
					overflowX={'hidden'}
					w={'100%'}
					gap={gridStyle == 'grid' ? '30px' : '15px'}
				>
					{!loading && (
						<LayoutMiniatureCreateNew key={-1} gridStyle={gridStyle} viewList={viewList} setViewList={setViewList} />
					)}
					{getViewsData({ filter, filteredViewList, viewList }).map((layout, index) => {
						// return gridStyle=='row'?
						// <LayoutMiniatureRow key={layout.viewId} index={index} viewList={viewList} setViewList={setViewList} layout={layout}></LayoutMiniatureRow>
						// :<LayoutMiniatureGrid key={layout.viewId} index={index} viewList={viewList} setViewList={setViewList} layout={layout}></LayoutMiniatureGrid>
						return (
							<LayoutMiniatureGrid
								key={layout.viewId}
								gridStyle={gridStyle}
								index={index}
								viewList={viewList}
								setViewList={setViewList}
								layout={layout}
								dMOnOpen={dMOnOpen}
								setViewToDelete={setViewToDelete}
								userInfo={userInfo}
								setCloningModalIsOpen={setCloningModalIsOpen}
							></LayoutMiniatureGrid>
						);
					})}
				</Flex>
				{/* {(filteredViewList.length && filteredViewList || viewList).map(layout=>{
                        return <ReactQuill theme='bubble' value={layout.viewName}/>
                    })} */}
			</Box>
			<RemoveProjectModal
				isOpen={dMIsOpen}
				onClose={dMOnClose}
				{...{ viewToDelete, setViewToDelete, viewList, setViewList, userInfo }}
			/>
			<CloningModal {...{ isOpen: cloningModalIsOpen }} />
		</React.Fragment>
	);
};

export default Home;
